import { render, staticRenderFns } from "./BrandPaletteGenerator.vue?vue&type=template&id=42c721e7&"
import script from "./BrandPaletteGenerator.vue?vue&type=script&lang=ts&"
export * from "./BrandPaletteGenerator.vue?vue&type=script&lang=ts&"
import style0 from "./BrandPaletteGenerator.vue?vue&type=style&index=0&id=42c721e7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports